import { render, staticRenderFns } from "./_GDPR.vue?vue&type=template&id=137a0e0d&scoped=true&"
import script from "./_GDPR.vue?vue&type=script&lang=js&"
export * from "./_GDPR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a0e0d",
  null
  
)

export default component.exports